import gql from "graphql-tag";

const deleteSavedPage = gql`
    mutation DeleteSavedPage($input: SavedPageInput!) {
        DeleteSavedPage(input: $input)
    }
`;

export default deleteSavedPage;
